import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode, JSX } from 'react';
import { twMerge } from 'tailwind-merge';
import type { CommonProps } from '../../../types';
import { CloseIcon, ButtonOrLink } from '../../../';

export interface ModalHeaderProps
    extends CommonProps,
        VariantProps<typeof ModalHeaderStyles> {
    onClose?: () => void;
    children?: ReactNode;
}

export const ModalHeaderStyles = cva(
    'flex items-center gap-2 py-4 px-7 md:px-8'
);

export const ModalHeader = ({
    onClose,
    className,
    children,
    testId = 'modal-header',
    ...props
}: ModalHeaderProps): JSX.Element => {
    return (
        <div
            className={twMerge(ModalHeaderStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            <div className="flex grow items-center justify-between">
                {children}
            </div>
            <ButtonOrLink
                className="inline-flex flex-none rounded-full border border-black p-[7px] leading-none"
                onClick={onClose}
            >
                <CloseIcon size="md" />
            </ButtonOrLink>
        </div>
    );
};
